const attendance = {
  init: function () {
    'use strict';
    $('.info-card').on('click', function () {
      const clickedID = $(this)[0].id;
      $('.' + clickedID).click();
    });
  }
};

if ($('.channel-container').length) {
  attendance.init();
}
